exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@import \"https://fonts.googleapis.com/css?family=Saira+Extra+Condensed:100,200,300,400,500,600,700,800,900\";\n@import \"https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i\";\n/* You can add global styles to this file, and also import other style files */\na {\n    cursor: pointer;    \n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/munkhuu/Desktop/mum/CS572/resume/node_modules/css-loader?{"sourceMap":false,"import":false}!/home/munkhuu/Desktop/mum/CS572/resume/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/home/munkhuu/Desktop/mum/CS572/resume/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles